
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/[eoiSlug]",
      function () {
        return require("private-next-pages/buy/[eoiSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/[eoiSlug]"])
      });
    }
  